import firebase from "datastore/database";
import store from "datastore/store";

export default function observeRestaurantPayments(businessUid) {
  store.dispatch({ type: "ADD_RESTAURANT_PAYMENTS_LOADING" });
  return firebase
    .firestore()
    .collection(`restaurant-payments/business/${businessUid}`)
    .onSnapshot((doc) => {
      const data = Object.create(null);
      doc.forEach((item) => (data[item.id] = item.data()));
      store.dispatch({ type: "SET_RESTAURANT_PAYMENTS", data });
    });
}
